<template>
</template>

<script>
import printHtml from '@/mixins/printHtml'

export default {
  name: 'PlanningForecastingPrint',
  mixins: [printHtml],
  props: {
    list: {type:Array, required:true},
    periods: {type:Array, required:true},
    preferences: {type:Object, required:true},
    showActuals: {type:Boolean, required:false, default:false},
    showOnHand: {type:Boolean, required:false, default:false}
  },
  async created() {
    this.$emit('close');
    const lines = [`
      <style>
        @page {size:landscape}
        .print {font-family: Roboto, sans-serif; width:100%;border-spacing:0;font-size:12px;text-align:left;border-collapse:collapse;table-layout:fixed}
        .print th {font-weight:normal;vertical-align:middle}
        .print .header {border:1px solid #888;text-align:center;padding:4px 8px}
        .print .title {font-size:18px;text-align:center;padding-bottom:20px}
        .print td {padding:8px 8px}
        .print .right {text-align:right}
        .print .left {text-align:left}
        .print .indent {text-indent:20px}
      </style>
      <table class="print">
        <col style="width:22%"/><col style="width:2%"/>
        <col style="width:6.5%"/><col style="width:6.5%"/><col style="width:6.5%"/>
        <col style="width:6.5%"/><col style="width:6.5%"/><col style="width:6.5%"/>
        <col style="width:6.5%"/><col style="width:6.5%"/><col style="width:6.5%"/>
        <col style="width:6.5%"/><col style="width:6.5%"/><col style="width:6.5%"/>
        <thead>
          <tr>
            <th class="title" colspan="14">Forecast</th>
          </tr>
          <tr>
            <th colspan="2" class="header left">Product${this.preferences.byCustomer?`/Customer`:``}</th>`];
    this.periods.forEach(period => {
      lines.push(`<th class="header">${period.title}</th>`)
    });

    lines.push(`
          </tr>
        </thead>
        <tbody>`);

    this.list.forEach(product => {
      lines.push(`<tr>
                    <td>${product.name}</td>
                    <td>
                      ${this.showActuals || this.showOnHand ? `F${this.showActuals ? `<div>A</div>` : ``}${this.showOnHand ? `<div>#</div>` : ``}` : ``}
                    </td>`);
      this.periods.forEach(period => {
        lines.push(`<td class="right">
                      ${this.productForecast(product, period.date, true)}
                      ${this.showActuals ? `<div>${this.productActual(product, period.date, true)}</div>` : ``}
                      ${this.showOnHand ? `<div>${this.productEstimated(product, period.date, true)}</div>` : ``}
                    </td>`);
      });
      lines.push(`</tr>`);

      if (this.preferences.byCustomer)
        product.customers.forEach(customer => {
          lines.push(`<tr>
                        <td class="indent">${customer.name}</td>
                        <td>
                          ${this.showActuals ? `F<div>A</div>` : ``}
                        </td>`);
          this.periods.forEach(period => {
            lines.push(`<td class="right">
                          ${this.productForecast(customer, period.date, true)}
                          ${this.showActuals ? `<div>${this.productActual(customer, period.date, true)}</div>` : ``}
                        </td>`);
          });
          lines.push(`</tr>`);
        });
    });

    lines.push(`</tbody>
              </table>`);

    this.printHtml('Forecast',lines.join(''));
  },
  methods: {
    productForecast(product, date, formatted) {
      const quantity = product.forecast.find(forecast => forecast.date === date)?.quantity ?? 0;
      return formatted ? this.$number(quantity, 0) : quantity;
    },
    productActual(product, date, formatted) {
      const quantity = product.actuals.find(actual => actual.date === date)?.quantity ?? 0;
      return formatted ? this.$number(quantity, 0) : quantity;
    },
    productEstimated(product, date, formatted) {
      const quantity = product.onHand.find(onHand => onHand.date === date)?.quantity ?? 0
      return formatted ? this.$number(quantity, 0) : quantity;
    }
  }
}
</script>